export default "__VITE_ASSET__MsUCEc7G__"